var render = function () {
  var _class, _class2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.categoryIconContainer] = true, _class[_vm.$style.active] = _vm.active, _class),
    attrs: {
      "data-category-icon": ""
    },
    on: {
      "mouseenter": function mouseenter($event) {
        _vm.isHover = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.isHover = false;
      },
      "touchend": function touchend($event) {
        _vm.isHover = false;
      }
    }
  }, [_c('MottoIcon', {
    class: _vm.$style.categoryIcon,
    attrs: {
      "name": _vm.getCategoryIcon,
      "icon-color": "white"
    }
  }), _c('div', {
    class: (_class2 = {}, _class2[_vm.$style.bottomLayer] = true, _class2[_vm.$style.active] = _vm.active, _class2)
  }, [_c('p', {
    staticClass: "overline-text"
  }, [_vm._v(_vm._s(_vm.categoryName))])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }